import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../LinkProvider";
import { useContext } from "react";


function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  // 🚫 Блокировка прокрутки body при открытом меню
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Очистка на случай размонтирования
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <div>
      <div
        className="relative z-[999] w-[30px] h-[15px] cursor-pointer flex flex-col justify-between xl:hidden"
        onClick={toggleMenu}
      >
        <div
          className={`w-full h-[1px] transition duration-300 transform ${
            isOpen
              ? "rotate-45 translate-y-[9px] bg-[#061A77] w-[35px]"
              : "bg-[#FFF]"
          }`}
        ></div>
        <div
          className={`w-full h-[1px] transition duration-300 transform ${
            isOpen
              ? "-rotate-45 -translate-y-[5px] bg-[#061A77] w-[35px]"
              : "bg-[#FFF] w-[20px] ml-auto"
          }`}
        ></div>
      </div>

      {/* Меню */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-2/3 bg-[#EFF2FE] z-[500] transform transition-all duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col items-center mt-[100px] gap-[15px]">
          <Link to="/products">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/products" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.1")}
            </p>
          </Link>
          <Link to="/investment">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/investment" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.2")}
            </p>
          </Link>
          <Link to="/accounttypes">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/accounttypes" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.account")}
            </p>
          </Link>
          <Link to="/ambassador">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/ambassador" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.3")}
            </p>
          </Link>
          <Link to="/about">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/about" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.4")}
            </p>
          </Link>
          <Link to="/contact">
            <p
              className={`text-[18px] roboto ${
                location.pathname === "/contact" ? "font-bold" : "font-medium"
              }`}
              onClick={toggleMenu}
            >
              {t("header.5")}
            </p>
          </Link>

          <a href={link}>
            <div className="butt hover:scale-[1.1] transition-all !bg-[#061A77]">
                <p className="roboto text-[14px] uppercase text-white py-[8px] px-[18px]">{t('header.button')}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
